module.exports = __webpack_public_path__ + "img/Banner-03.308d7729.png";